import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::socialLogin
* @see app/Http/Controllers/User/Auth/SocialiteController.php:13
* @route '/user/social-login/{provider}'
*/
export const socialLogin = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: socialLogin.url(args, options),
    method: 'get',
})

socialLogin.definition = {
    methods: ["get","head"],
    url: '/user/social-login/{provider}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::socialLogin
* @see app/Http/Controllers/User/Auth/SocialiteController.php:13
* @route '/user/social-login/{provider}'
*/
socialLogin.url = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { provider: args }
    }

    if (Array.isArray(args)) {
        args = {
            provider: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        provider: args.provider,
    }

    return socialLogin.definition.url
            .replace('{provider}', parsedArgs.provider.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::socialLogin
* @see app/Http/Controllers/User/Auth/SocialiteController.php:13
* @route '/user/social-login/{provider}'
*/
socialLogin.get = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: socialLogin.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::socialLogin
* @see app/Http/Controllers/User/Auth/SocialiteController.php:13
* @route '/user/social-login/{provider}'
*/
socialLogin.head = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: socialLogin.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::socialLogin
* @see app/Http/Controllers/User/Auth/SocialiteController.php:13
* @route '/user/social-login/{provider}'
*/
const socialLoginForm = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: socialLogin.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::socialLogin
* @see app/Http/Controllers/User/Auth/SocialiteController.php:13
* @route '/user/social-login/{provider}'
*/
socialLoginForm.get = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: socialLogin.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::socialLogin
* @see app/Http/Controllers/User/Auth/SocialiteController.php:13
* @route '/user/social-login/{provider}'
*/
socialLoginForm.head = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: socialLogin.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

socialLogin.form = socialLoginForm

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::callback
* @see app/Http/Controllers/User/Auth/SocialiteController.php:37
* @route '/user/social-login/callback/{provider}'
*/
export const callback = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(args, options),
    method: 'get',
})

callback.definition = {
    methods: ["get","head"],
    url: '/user/social-login/callback/{provider}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::callback
* @see app/Http/Controllers/User/Auth/SocialiteController.php:37
* @route '/user/social-login/callback/{provider}'
*/
callback.url = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { provider: args }
    }

    if (Array.isArray(args)) {
        args = {
            provider: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        provider: args.provider,
    }

    return callback.definition.url
            .replace('{provider}', parsedArgs.provider.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::callback
* @see app/Http/Controllers/User/Auth/SocialiteController.php:37
* @route '/user/social-login/callback/{provider}'
*/
callback.get = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::callback
* @see app/Http/Controllers/User/Auth/SocialiteController.php:37
* @route '/user/social-login/callback/{provider}'
*/
callback.head = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: callback.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::callback
* @see app/Http/Controllers/User/Auth/SocialiteController.php:37
* @route '/user/social-login/callback/{provider}'
*/
const callbackForm = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::callback
* @see app/Http/Controllers/User/Auth/SocialiteController.php:37
* @route '/user/social-login/callback/{provider}'
*/
callbackForm.get = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteController::callback
* @see app/Http/Controllers/User/Auth/SocialiteController.php:37
* @route '/user/social-login/callback/{provider}'
*/
callbackForm.head = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

callback.form = callbackForm

const SocialiteController = { socialLogin, callback }

export default SocialiteController